package com.sweetlime.bingeamigo.state

sealed class LibraryUiState {
    object Idle    : LibraryUiState()
    object Loading : LibraryUiState()
    data class Error(val message: String) : LibraryUiState()
}